import http from '@/api/http'
import type * as Types from '../utils/types'
import qs from 'qs'

// Catalog
export const refreshcatalog = () => http.get(`/catalog/refreshcatalog`)

export const getCatalog = () => http.get(`/catalog`)

export const getMixedSheets = () => http.get(`/catalog/mixedsheets`)

// Products
export const getProduct = (productId: number) =>
    http({
        url: '/catalog/products/' + productId,
        method: 'get'
    })

export const updateProduct = (product: Types.IProduct) => http.put(`/catalog/products`, product)

export const deleteProduct = (productId: number) => http.delete(`/catalog/products/${productId}`)

export const createProduct = (product: Types.IProduct) => http.post(`/catalog/products`, product)

export const getProductDesigns = (productId: number) =>
    http({
        url: '/catalog/products/' + productId + '/designs',
        method: 'get'
    })

// Product Categories
export const getProductCategory = (id: number) => http.get(`/catalog/productcategories/${id}`)

export const updateProductCategory = (productCategory: Types.IProductCategory) => http.put(`/catalog/productcategories`, productCategory)

export const deleteProductCategory = (productCategoryId: number) => http.delete(`/catalog/productcategories/${productCategoryId}`)

export const createProductCategory = (productCategory: Types.IProductCategory) => http.post(`/catalog/productcategories`, productCategory)

// Designs
export const getArtDesigns = (params: Types.IPagination, filterText: string) => {
    const query = `${qs.stringify(params)}&filterText=${filterText}`
    return http.get(`/catalog/designs/art?${query}`)
}

export const getDesign = (id: number) => http.get(`/catalog/designs/${id}`)

export const updateDesign = (art: Types.IDesign) => http.put(`/catalog/designs`, art)

export const createDesign = (art: Types.IDesign) => http.post(`/catalog/designs`, art)

// combo of update/create design
export function saveDesign(art: Types.IDesign) {
    if (art.id > 0) {
        return http.put(`/catalog/designs`, art) //update existing
    } else {
        return http.post(`/catalog/designs`, art) //create new
    }
}

export const getDesignAmazonListings = (designId: number) => http.get(`/catalog/designs/amazonlistings/${designId}`)

export const deleteDesign = (id: number) => http.delete(`/catalog/designs/${id}`)

export const getNextDesignid = () => http.get('/catalog/designs/nextdesignid')

// Design Categories
export const getDesignCategory = (id: number) => http.get(`/catalog/designcategories/${id}`)

export const updateDesignCategory = (designCategory: Types.IDesignCategory) => http.put(`/catalog/designcategories`, designCategory)

export const deleteDesignCategory = (designCategoryId: number) => http.delete(`/catalog/designcategories/${designCategoryId}`)

export const createDesignCategory = (designCategory: Types.IDesignCategory) => http.post(`/catalog/designcategories`, designCategory)

// Packages
export const getPackage = (packageId: number) => http.get(`/catalog/packages/${packageId}`)

export const updatePackage = (catalogPackage: Types.IPackage) => http.put(`/catalog/packages`, catalogPackage)

export const deletePackage = (packageId: number) => http.delete(`/catalog/packages/${packageId}`)

export const createPackage = (catalogPackage: Types.IPackage) => http.post(`/catalog/packages`, catalogPackage)

// Mixed sheets
export const getMixedSheet = (mixedSheetId: number) => http.get(`/catalog/mixedsheets/${mixedSheetId}`)

export const updateMixedSheet = (mixedSheet: Types.IMixedSheet) => http.put(`/catalog/mixedsheets`, mixedSheet)

export const deleteMixedSheet = (mixedSheetId: number) => http.delete(`/catalog/mixedsheets/${mixedSheetId}`)

export const createMixedSheet = (mixedSheet: Types.IMixedSheet) => http.post(`/catalog/mixedsheets`, mixedSheet)

// Artists
export const getArtists = () => http.get(`/catalog/artists`)

export const createArtist = (artist: Types.IArtist) => http.post(`/catalog/artist`, artist)

export const updateArtist = (artist: Types.IArtist) => http.put(`/catalog/artist/${artist.id}`, artist)

export const deleteArtist = (artist: Types.IArtist) => http.delete(`/catalog/artist/${artist.id}`)

// Art data
export const getTags = () => http.get(`/art/tags`)

